import CONSTANTS from '../CONSTANTS';

const initialState = {
  assets: {},
  types: {},
  availableAssets: {},
  search: "",
  assetEdit: {}
};

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.ASSETS_SET_LIST:
      return { ...state, assets: action.assets };
    case CONSTANTS.ASSETS_SET_AVAILABLE :
      return { ...state, availableAssets: action.assets };
    case CONSTANTS.ASSETS_SET_EDIT:
      return { ...state, assetEdit: action.asset };

    case CONSTANTS.ASSETS_UPDATE_LOCAL_ASSET: {

      //get list of asset IDs only
      let assetIdList = state.assets.data.map(a => a._id);
      let newAssetList = [...state.assets.data];
      const assetIndex = assetIdList.indexOf(action.asset);

      if (assetIndex > -1) {
        newAssetList[assetIndex].status = action.status;
      }

      return {...state, assets: {...state.assets, data: [...newAssetList]}};
    }

    case CONSTANTS.ASSETS_SET_TYPES:
      return { ...state, types: action.types };
      
    default:
      return state;
  }
};

export default assetsReducer;